<template>
  <div>
    <div id="template" style="display: none;">
      <div class="dz-preview dz-file-preview">
        <div class="dz-image" style="display: none;"></div>
        <div class="dz-details" style="display: none;">
          <div class="dz-filename"><span data-dz-name></span></div>

        </div>
        <div class="dz-filename"><span data-dz-name></span></div>
      </div>
    </div>

    <div v-if="currenMaxFiles > 0">
      <dropzone :id="docType+'-'+application.id"
                :options="dropzoneOpt"
                v-on:vdropzone-sending="sendingEvent"
                v-on:vdropzone-success="showSuccess"
                v-on:vdropzone-removed-file="removeDocument"
                v-on:vdropzone-maxfiles-exceeded="maxFilesExceeded"
                :preview-template="template">
      </dropzone>
    </div>
    <div class="vue-dropzone dropzone" v-else>
      <div class="dz-default dz-message">
        <div><i class="fa fa-ban fa-2x" aria-hidden="true"></i>
          <br>{{ $t('candidate.documents.validation.max_doc') }}

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Dropzone from 'vue2-dropzone'

import api from 'services/candidate'

const AUTH_TOKEN = localStorage.getItem('token')

export default {
  components: {
    Dropzone
  },
  props: {
    candidate: {type: Object},
    docType: {type: String},
    maxFiles: {type: Number}
  },
  data() {
    return {
      currenMaxFiles: this.maxFiles,
      errorMsg: '',
      csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
      csrfHeader: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
        'Authorization': `Bearer ${AUTH_TOKEN}`
      },
      dropzoneOpt: {
        url: '//' + window.location.hostname + '/api/candidate/application/documents',
        previewTemplate: this.template(),
        dictDefaultMessage: '<i class=\'fa fa-cloud-upload\'></i><br>' + this.$t('candidate.documents.document_drag'),
        dictRemoveFile: this.$t('labels.general.delete'),
        dictMaxFilesExceeded: this.$t('candidate.documents.validation.max_doc'),
        dictFileTooBig: this.$t('candidate.documents.validation.size_doc') + ' ({{filesize}}MiB). Maximum: {{maxFilesize}}MiB.',
        dictCancelUpload: this.$t('labels.general.cancel'),
        maxFiles: this.maxFiles,
        maxFilesize: this.maxFilesize,
        headers: this.csrfHeader
      },
      documentsList: []
    }
  },

  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      token: 'auth/getToken',
      account: 'auth/getAccount'
    }),
    application() {
      return this.candidate.applications
    },
  },
  watch: {
    // call again the method if the route changes
    '$route': 'init'
  },

  filters: {
    json(value) {
      return JSON.stringify(value, null, 2)
    }
  },
  methods: {
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    init() {
      this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
      this.csrfHeader = {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
        'Authorization': `Bearer ${AUTH_TOKEN}`
      }
    },
    showSuccess(file, response) {
      this.currenMaxFiles--
      // Émet un événement personnalisé avec la réponse du serveur
      this.$emit('file-upload-success', response);

      // Ton code existant
      this.errorMsg = '';
      this.documentsList.push(file);
      this.$emit('success', response);
    },
    removeDocument(file, error, xhr) {
      if (file.xhr && this.application.docComplete === false) {
        const response = JSON.parse(file.xhr.response)
        api.removeDocument(response).then((result) => {
          this.currenMaxFiles++
        }).catch(e => {

        })
      }
    },
    sendingEvent(file, xhr, formData) {
      formData.append('application_id', this.application.id);
      formData.append('candidate_id', this.candidate.id);
      formData.append('user_id', this.account.id);
      formData.append('doc_type', this.docType);
    },
    maxFilesExceeded(file) {
      this.$emit('max-files-exceeded', file); // Émet un événement personnalisé
      // ou tu pourrais également mettre à jour une variable d'état pour afficher un message d'erreur
      this.errorMsg = 'Nombre maximum de fichiers atteint.';
    },
    template: function () {
      return `
                  <div class="dz-preview dz-file-preview">
                      <div class="dz-image" style="display: none">
                          <img data-dz-thumbnail /></div>
                      <div class="dz-details" style="display: none">
                        <div class="dz-filename"><span data-dz-name></span></div>
                      </div>
                      <div class="dz-filename"><span data-dz-name></span></div>
                      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                      <div class="dz-error-message"><span data-dz-errormessage></span></div>
                      <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                      <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                  </div>
              `
    }
  },
}
</script>

<style lang="scss">

.doc-type {
  min-height: 5rem;
  color: #0f1e44
}

.doc-type-title {
  margin-bottom: 0.3em;
}

.doc-type-subtitle {
  color: #0f1e44;
  font-style: italic;
  font-size: 0.9rem;
  /*max-width: 15rem;*/
}

.doc-list {

}

.dropzone {
  min-height: 72px;
  padding: 10px 0;
}

.dropzone .dz-message {
  text-align: center;
  margin: 0 0;
}

.dropzone .dz-preview {
  margin-top: 3px;
  min-height: 10px;
}

.vue-dropzone .dz-preview {
  height: 0px !important;
}

.dropzone .dz-preview.dz-error .dz-error-mark .fa {
  color: red;
}

.dropzone .dz-preview.dz-success .dz-success-mark .fa {
  color: green;
}

.vue-dropzone {
  .dz-preview {
    height: 50px;

    .dz-details {

    }
  }
}
</style>
